export const clone = object => JSON.parse(JSON.stringify(object));
export const map = (array) => {
  const map = {};
  array.forEach((item) => {
    map[item.id] = item;
  });
  return map;
};
export const array = (map) => {
  const array = [];
  for (const key in map) {
    array.push(map[key]);
  }
  return array;
};
export const reflect = (fromObject, toObject) => {
  for(const key in fromObject) {
    toObject[key] = fromObject[key];
  }
};
export const filterMap = (map, property, value) => {
  const filtered = [];
  for(const key in map) {
    if(map[key][property]
        && map[key][property] == value
        && (!map[key].deletedAt || map[key].deletedAt === null)) {
      filtered.push(map[key]);
    }
  }
  return filtered;
};
export const autoLoad = async (map, mapName, module) => {
  // map have zero key
  // module is auto load
  // map is not marked as empty
  // when module is not loading
  // only do it 5 times

  if (Object.keys(map).length == 0
      && module.autoLoad
      && !module.autoLoad.emptyMap[mapName]
      && module.autoLoad.loading === false
      && (!module.autoLoad.counter || module.autoLoad.counter < 5)) {
    module.autoLoad.loading = true;
    const mapNames = [];
    Object.keys(module).forEach(key => {
      if(typeof(module[key]) == 'object' && Object.keys(module[key]).length == 0) {
        mapNames.push(key);
      }
    });
    const response = await module.autoLoad.loader.call();

    if (response) {
      mapNames.forEach(name => {
        if(typeof(response[name]) != 'undefined') {
          if(Array.isArray(response[name])) {
            response[name].forEach((item) => {
              module[name][item.id] = item;
            });
            if(Object.keys(module[name]).length == 0) {
              module.autoLoad.emptyMap[name] = true;
            }
          } else {
            module[name] = response[name];
          }
        } else {
          console.warn('MODULE AUTOLOADED BUT API RESPONSE NO DATA FOR THIS MAP <' + name + '>', module);
        }
      });

    }
    if(!module.autoLoad.counter) module.autoLoad.counter = 1;
    else module.autoLoad.counter ++;
    module.autoLoad.loading = false;
  }
};
export const classMap =  {
  'Customer': 'customers',
};

export const caseStripRelation = (text) => {
  const relationMap = {
  };
  // convert camelCase and snake_case to normal case
  const caseStrippedRelation = text
                                .replace(/[A-Z]/g, m => "_" + m.toLowerCase())
                                .split('_')
                                .join(' ')
                                .toLowerCase().trim();
  if(typeof(relationMap[caseStrippedRelation]) != 'undefined') {
    if(relationMap[caseStrippedRelation] == '') return '';
    return relationMap[caseStrippedRelation];
  } else {
    return caseStrippedRelation
            .replace(/\w\S*/g, function(txt) {
              return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
            });
  }
}

export const constant =  {
  
};


export default {};
